/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LabelTranTypeConversionModel { 
    labelTranTypeConversionId?: number;
    labelTranId?: number;
    fromLocationId?: number;
    fromSiteId?: number;
    fromItemNumber?: string | null;
    fromInvTranId?: number | null;
    toLocationId?: number;
    toSiteId?: number;
    toItemNumber?: string | null;
    toInvTranId?: number | null;
    toExpDate?: string | null;
    fromLocationIdentifier?: string | null;
    fromSiteName?: string | null;
    fromLocationTimeZone?: string | null;
    toLocationIdentifier?: string | null;
    toSiteName?: string | null;
    fromInvTranNumber?: string | null;
    toInvTranNumber?: string | null;
    fromItemDescription?: string | null;
    toItemDescription?: string | null;
}

